import { put } from 'redux-saga/effects';
import { fetchEventsFail, fetchEventsSuccess } from './actions';
import { getEvents } from './events.backend';
import { makeErrorPayload } from '../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../shared/toast/redux/actions';
import { pagingParams } from '../../../../../shared/helpers/url-params.helper';

export function* fetchEventsSaga(action) {
    try {
        const {
            ruleCategory,
            sort,
            pagination,
            brandId,
            jurisdictionCode,
            eventType
        } = action.payload;

        const response = yield getEvents({
            ruleCategory,
            jurisdiction: jurisdictionCode,
            brandId,
            ...sort,
            ...pagingParams(pagination),
            eventType
        });
        yield put(fetchEventsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchEventsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
